/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo } from 'react';
import Wysiwyg from 'components/blocks/wysiwyg/Wysiwyg';
import useTokenReplacement from 'hooks/custom/useTokenReplacement';
import { FooterLinkItem } from 'types';
import FooterLink from './FooterLink';
import SocialLinks, { SocialLinkItem } from './SocialLinks';

interface ClickPortalSiteFooterProps {
  siteName?: string;
  footerText?: string;
  footerLinks?: FooterLinkItem[];
  socialLinks?: SocialLinkItem[];
  socialLinksTitle?: string;
}

function ClickPortalSiteFooter({
  siteName,
  footerText = '',
  footerLinks,
  socialLinks,
  socialLinksTitle,
}: ClickPortalSiteFooterProps): React.ReactElement | null {
  const currentYear = useMemo(() => new Date().getFullYear(), []);

  const tokenizedWysiwygText = useTokenReplacement(footerText);

  return (
    <footer className="footer footer--clickPortal" role="contentinfo">
      <div className="footer__inner">
        <div className="footer__section">
          <div className="footer__branding">
            <div className="footer__logo">
              <span className="isVisuallyHidden">{siteName}</span>
            </div>
            {socialLinks && socialLinks.length > 0 && (
              <div className="footer__social">
                <SocialLinks
                  socialLinks={socialLinks}
                  socialLinksTitle={socialLinksTitle}
                />
              </div>
            )}
          </div>
          <div className="footer__nav">
            <div className="footer__navSection">
              {footerLinks && (
                <ul className="footer__links">
                  {footerLinks.map((footerLink) => (
                    <li key={footerLink.link} className="footer__linkItem">
                      <FooterLink
                        link={footerLink.link}
                        label={footerLink.label}
                        trigger={footerLink.trigger}
                      />
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
        <div className="footer__section">
          <div className="footer__text">
            <Wysiwyg content={tokenizedWysiwygText} />
            <div className="footer__attribution" suppressHydrationWarning>
              {`© ${currentYear} `}
              <a
                href="https://www.triadms.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                TriAd Media Solutions, Inc.
              </a>
              {' All Rights Reserved'}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default ClickPortalSiteFooter;
